import React, { useState, useEffect, useLayoutEffect } from 'react';
import config from 'artsteps2-config/public.json';
import SportsSoccerIcon from '@material-ui/icons/SportsSoccer';
import PaymentIcon from '@material-ui/icons/Payment';
import Box from '@material-ui/core/Box';
import TwitterIcon from '@material-ui/icons/Twitter';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import InstagramIcon from '@material-ui/icons/Instagram';
import { getAuthUser, getUIProperty } from '../../reducers';
import { compose, withState, withDispatch } from '../../enhancers';
import { setUIProperty } from '../../actions';
import Link from '../generic/Link';
import AppIconsSection from '../generic/AppIconsSection';
import logo from '../../styles/images/logo.png';
import Grid from '@material-ui/core/Grid';
import * as footer from '../../styles/styledComponents/footer';
import * as generic from '../../styles/GenericStyled';
import Newsletter from '../subscribers/forms/Newsletter';
// import CategoryList from '../articles/lists/CategoryList';
import OurModal from '../../components/generic/OurModal';
import Paypal from '../../modal_content/Paypal';

const GOOGLE_PLAY_URI = config.applications.playURI;
const APP_STORE_URI = config.applications.itunesURI;

function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
}

const social = [
  {
    path: 'https://www.facebook.com/Artsteps/',
    icon: <FacebookIcon style={{ fontSize: 40 }} />,
  },
  {
    path:
      'https://www.instagram.com/artsteps_stories/?utm_source=ig_embed&ig_mid=C536EFFA-D7BF-45E6-BB52-7E3E4A926088',
    icon: <InstagramIcon style={{ fontSize: 40 }} />,
  },
  {
    path: 'https://www.linkedin.com/company/artsteps/',
    icon: <LinkedInIcon style={{ fontSize: 40 }} />,
  },
  {
    path: 'https://twitter.com/artsteps_?lang=en',
    icon: <TwitterIcon style={{ fontSize: 40 }} />,
  },
];

const footerItems = [
  {
    header: 'Artsteps',
    items: [
      { name: 'About us', path: '/article/contact-us' },
      { name: 'Exhibitions', path: '/explore' },
      { name: 'Contact', path: '/contact' },
      { name: 'Features', path: '/tour' },
    ],
  },
  {
    header: 'Legal',
    items: [
      { name: 'Cookies', path: '/article/cookies' },
      { name: 'Terms of Service', path: '/article/terms-of-service' },
      { name: 'Privacy Policy', path: '/article/privacy-policy' },
    ],
  },
  {
    header: 'Support',
    items: [
      { name: 'Professional Services', path: '/article/professional-services' },
      { name: 'Help', path: '/categories/help' },
      { name: 'FAQ', path: '/faq' },
    ],
  },
];

const ButtonList = action => [
  {
    name: 'Get Verified on Artsteps',
    action: action[0],
    icon: <SportsSoccerIcon />,
    fillcolor: '#12AD8F',
    color: '#12AD8F',
  },
  {
    name: 'Donate an amount',
    action: () => action[1](true),
    icon: <PaymentIcon />,
    fillcolor: '#ECC62C',
    color: '#ECC62C',
  },
];

const List = () => (
  <>
    {footerItems.map((element, index) => (
      <footer.ListSection key={index} index={index}>
        <generic.Text type="h5">{element.header}</generic.Text>
        <footer.StyledList>
          {element.items.map(item => (
            <li key={index + item.name}>
              <Link to={item.path}>
                <generic.Text component="span" type="body1" mycolor="#343a40b8" weight="600">
                  {item.name}
                </generic.Text>
              </Link>
            </li>
          ))}
        </footer.StyledList>
      </footer.ListSection>
    ))}
  </>
);

const Buttons = ({ actions, width }) => (
  <>
    {ButtonList(actions).map((button, index) => (
      <Box
        component={generic.StyledButton}
        boxShadow={5}
        key={index}
        background={`${button.color}1f`}
        mycolor={button.color}
        style={width > 960 ? { minWidth: '300px' } : { minWidth: '265px' }}
        onClick={button.action}
      >
        <footer.ButtonContent fillcolor={button.fillcolor}>
          {button.icon}
          <generic.Text
            component="span"
            style={{ paddingLeft: '10px', letterSpacing: 0, fontWeight: 600 }}
          >
            {button.name}
          </generic.Text>
        </footer.ButtonContent>
      </Box>
    ))}
  </>
);

export const DefaultFooterView = ({
  onContributeModalOpen = Promise.resolve(false),
  onToggleDonateModal = Promise.resolve(false),
  donateModal = false,
}) => {
  const [width] = useWindowSize();
  const [textAlign, setTextAlign] = useState('left');

  useEffect(() => {
    if (width >= 960) setTextAlign('left');
    else setTextAlign('center');
  }, [width]);

  return (
    <footer.StyledFooter>
      <OurModal width={400} height={550} openModal={donateModal} setOpenModal={onToggleDonateModal}>
        <Paypal />
      </OurModal>
      <Grid container wrap="wrap">
        <footer.Section item xs={12} md={3} textalign={textAlign}>
          <footer.BodyWithPadding>
            <generic.VerticalItems justify="flex-start">
              <img src={logo} alt="logo" width="176px" height="59px" />
              <generic.Text
                type="body1"
                mycolor="#343a40b8"
                weight="600"
                style={{ marginTop: '18px' }}
              >
                Artsteps provides you with a platform to create, design & share your own virtual
                exhibitions
              </generic.Text>
              <footer.IconsSection>
                <AppIconsSection googlePlayURI={GOOGLE_PLAY_URI} appStoreURI={APP_STORE_URI} />
              </footer.IconsSection>
              {width >= 960 && (
                <generic.Text
                  type="body2"
                  mycolor="#343A40"
                  weight="600"
                  style={{ marginTop: '20px' }}
                >
                  © 2020 Dataverse Ltd. All rights reserved.
                </generic.Text>
              )}
            </generic.VerticalItems>
          </footer.BodyWithPadding>
        </footer.Section>
        <footer.Section item xs={12} md={5} textalign={textAlign}>
          <generic.VerticalItems justify="flex-start" style={{ padding: '0 20px' }}>
            <footer.ListAlign>
              <List />
              {/** ****** Fetch and Edit Footer Catergories ****** */}
              {/* <div className="ui four wide column">
                <CategoryList header={4} displayChildren={1} fetchResources />
              </div> */}
            </footer.ListAlign>
            <generic.Text type="h5" mycolor="">
              Get Involved
            </generic.Text>
            <footer.ListAlign footerbuttons="true">
              <Buttons actions={[onContributeModalOpen, onToggleDonateModal]} width={width} />
            </footer.ListAlign>
          </generic.VerticalItems>
        </footer.Section>
        <footer.Section item xs={12} md={4} textalign={textAlign}>
          <Newsletter width={width} social={social} />
          {width < 960 && (
            <generic.Text type="body2" mycolor="#343A40" weight="600" style={{ marginTop: '20px' }}>
              © 2020 Dataverse Ltd. All rights reserved.
            </generic.Text>
          )}
        </footer.Section>

        {/* NewsLetter SECTION */}
        {/* <div className="ui four wide column">
        <CategoryList header={4} displayChildren={1} fetchResources />
      </div>

      {!isPrivateSpace && (
        <div className="ui three wide column">
          <h4>{__('subscribe')}</h4>
          <Newsletter />
        </div>
      )} */}
      </Grid>
    </footer.StyledFooter>
  );
};

const mapState = state => ({
  currentUser: getAuthUser(state),
  donateModal: getUIProperty(state, 'donateModal'),
});

const mapDispatch = dispatch => ({
  onContributeModalOpen: () => dispatch(setUIProperty('contributionModalOpen', true)),
  onToggleDonateModal: show => dispatch(setUIProperty('donateModal', show)),
});

const DefaultFooter = compose(withState(mapState), withDispatch(mapDispatch))(DefaultFooterView);

export default DefaultFooter;
